import { render, staticRenderFns } from "./LocalAcceptedMaterials.vue?vue&type=template&id=1ae1ebb5&"
import script from "./LocalAcceptedMaterials.vue?vue&type=script&lang=js&"
export * from "./LocalAcceptedMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports